import React from 'react';

import { LegendRender } from './legend-render';
import type { BaseLegendProps } from './types';

const BaseLegend = ({ seriesColorByName, seriesKeys, chartRef, hiddenSeries, setHiddenSeries }: BaseLegendProps) => {
  const allSeriesHidden = hiddenSeries.size === seriesKeys.length && seriesKeys.length > 0;

  React.useEffect(() => {
    if (chartRef.current?.onReady) {
      chartRef.current.onReady((seriesArray) => {
        if (!seriesArray) return;
        // Hide all series that are in the hiddenSeries set
        hiddenSeries.forEach((seriesName) => {
          const targetSeries = seriesArray.find((s: any) => s.get('name') === seriesName);
          if (targetSeries) {
            targetSeries.hide();
          }
        });
      });
    }
  }, [chartRef, hiddenSeries]);

  const handleClick = (seriesName: string) => {
    if (!chartRef.current?.series) return;

    const seriesArray = Array.isArray(chartRef.current.series) ? chartRef.current.series : [chartRef.current.series];
    const targetSeries = seriesArray.find((s: any) => s.get('name') === seriesName);

    if (targetSeries) {
      const isCurrentlyHidden = hiddenSeries.has(seriesName);
      if (isCurrentlyHidden) {
        targetSeries.show();
        setHiddenSeries((prev) => {
          const next = new Set(prev);
          next.delete(seriesName);
          return next;
        });
      } else {
        targetSeries.hide();
        setHiddenSeries((prev) => new Set(prev).add(seriesName));
      }
    }
  };

  const handleToggleAll = () => {
    if (!chartRef.current?.series) return;

    const seriesArray = Array.isArray(chartRef.current.series) ? chartRef.current.series : [chartRef.current.series];

    if (allSeriesHidden) {
      seriesKeys.forEach((seriesName) => {
        const targetSeries = seriesArray.find((s: any) => s.get('name') === seriesName);
        if (targetSeries) {
          targetSeries.show();
        }
      });
      setHiddenSeries(new Set());
    } else {
      seriesKeys.forEach((seriesName) => {
        const targetSeries = seriesArray.find((s: any) => s.get('name') === seriesName);
        if (targetSeries) {
          targetSeries.hide();
        }
      });
      setHiddenSeries(new Set(seriesKeys));
    }
  };

  return (
    <LegendRender
      seriesColorByName={seriesColorByName}
      seriesKeys={seriesKeys}
      hiddenSeries={hiddenSeries}
      allSeriesHidden={allSeriesHidden}
      onSeriesClick={handleClick}
      onToggleAll={handleToggleAll}
    />
  );
};

export default BaseLegend;
